var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#0156CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2983 18.5932C12.4 18.2148 11.9146 17.7705 11.3366 17.1947C11.1848 17.0434 10.9361 17.0648 10.8124 17.2406L10.4922 17.6958C10.3135 17.9498 10.3418 18.2978 10.5592 18.5185C10.8748 18.8389 11.292 19.0354 11.7367 19.073L12.6883 19.1535C12.9578 19.1763 13.2182 19.0487 13.3682 18.8203C13.421 18.7398 13.3863 18.6303 13.2983 18.5932Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6634 17.1947C20.0854 17.7705 19.6 18.2148 18.7017 18.5932C18.6137 18.6303 18.579 18.7398 18.6318 18.8203C18.7818 19.0487 19.0422 19.1763 19.3117 19.1535L20.2633 19.073C20.708 19.0354 21.1252 18.8389 21.4408 18.5185C21.6582 18.2978 21.6865 17.9498 21.5078 17.6958L21.1876 17.2406C21.0639 17.0648 20.8152 17.0434 20.6634 17.1947Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2667 12.7591L21.8966 14.2812H22.75C23.0607 14.2812 23.3125 14.533 23.3125 14.8437C23.3125 15.1543 23.0607 15.4062 22.75 15.4062H22.3621L22.4175 15.5401C23.0789 16.0904 23.5 16.9198 23.5 17.8474V20.0974C23.5 20.6527 23.1984 21.1374 22.75 21.3968V22.3437C22.75 22.7579 22.4142 23.0937 22 23.0937H21.25C20.8358 23.0937 20.5 22.7579 20.5 22.3437V21.5974H11.5V22.3437C11.5 22.7579 11.1642 23.0937 10.75 23.0937H10C9.58579 23.0937 9.25 22.7579 9.25 22.3437V21.3968C8.80165 21.1374 8.5 20.6527 8.5 20.0974V17.8474C8.5 16.9198 8.92107 16.0904 9.58251 15.5401L9.63793 15.4062H9.25C8.93934 15.4062 8.6875 15.1543 8.6875 14.8437C8.6875 14.533 8.93934 14.2812 9.25 14.2812H10.1034L10.7333 12.7591C11.1974 11.6376 12.2915 10.9062 13.5053 10.9062H18.4947C19.7085 10.9062 20.8026 11.6376 21.2667 12.7591ZM13.5053 12.4062H18.4947C19.1016 12.4062 19.6487 12.7719 19.8807 13.3327L20.506 14.8437H11.494L12.1193 13.3327C12.3513 12.7719 12.8984 12.4062 13.5053 12.4062ZM20.5 16.3474H11.5C10.6716 16.3474 10 17.019 10 17.8474V20.0974H13.3758C13.642 19.6331 14.1375 19.3437 14.6771 19.3437H17.3229C17.8625 19.3437 18.358 19.6331 18.6242 20.0974H22V17.8474C22 17.019 21.3284 16.3474 20.5 16.3474Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car-icon.b511ebaa77c5f13c474ef69acb4c1d27.svg";
export { ForwardRef as ReactComponent };